import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWlStylization = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 3.15C0 2.07704 0 1.54056 0.200504 1.12718C0.396555 0.72298 0.72298 0.396555 1.12718 0.200504C1.54056 0 2.07704 0 3.15 0H14.85C15.923 0 16.4594 0 16.8728 0.200504C17.277 0.396555 17.6034 0.72298 17.7995 1.12718C18 1.54056 18 2.07704 18 3.15C18 4.22296 18 4.75944 17.7995 5.17282C17.6034 5.57702 17.277 5.90344 16.8728 6.0995C16.4594 6.3 15.923 6.3 14.85 6.3H3.15C2.07704 6.3 1.54056 6.3 1.12718 6.0995C0.72298 5.90344 0.396555 5.57702 0.200504 5.17282C0 4.75944 0 4.22296 0 3.15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.2 12.1C7.2 10.2144 7.2 9.27157 7.78579 8.68579C8.37157 8.1 9.31438 8.1 11.2 8.1H14C15.8856 8.1 16.8284 8.1 17.4142 8.68579C18 9.27157 18 10.2144 18 12.1V14C18 15.8856 18 16.8284 17.4142 17.4142C16.8284 18 15.8856 18 14 18H11.2C9.31438 18 8.37157 18 7.78579 17.4142C7.2 16.8284 7.2 15.8856 7.2 14V12.1Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 10.8C0 10.1489 0 9.82337 0.0750894 9.55712C0.263973 8.88739 0.787388 8.36397 1.45712 8.17509C1.72337 8.1 2.04891 8.1 2.7 8.1C3.35109 8.1 3.67663 8.1 3.94288 8.17509C4.61261 8.36397 5.13603 8.88739 5.32491 9.55712C5.4 9.82337 5.4 10.1489 5.4 10.8V15.3C5.4 15.9511 5.4 16.2766 5.32491 16.5429C5.13603 17.2126 4.61261 17.736 3.94288 17.9249C3.67663 18 3.35109 18 2.7 18C2.04891 18 1.72337 18 1.45712 17.9249C0.787388 17.736 0.263973 17.2126 0.0750894 16.5429C0 16.2766 0 15.9511 0 15.3V10.8Z",
			fill: "currentColor"
		})
	]
});
export default SvgWlStylization;
